// src/components/Auth/FirstLoginRedirect.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

/**
 * Componente que verifica se o usuário tem um documento na coleção userCategories
 * Se não tiver, redireciona para a página de seleção de categorias
 * Colaboradores não são redirecionados para seleção de categorias
 */
const FirstLoginRedirect = ({ children }) => {
  const { user, loading, activeAccountType } = useUserContext();
  const [hasCategoriesDoc, setHasCategoriesDoc] = useState(null);
  const [isCollaborator, setIsCollaborator] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    // Verificar se o usuário está autenticado e não estamos carregando
    if (user && !loading) {
      checkUserStatus();
    } else if (!loading && !user) {
      // Se não estamos carregando e não temos usuário, definir como falso
      setHasCategoriesDoc(false);
      setIsCollaborator(false);
      setCheckingStatus(false);
    }
  }, [user, loading, activeAccountType]);

  const checkUserStatus = async () => {
    try {
      setCheckingStatus(true);
      
      // 1. Verificar se o usuário é um colaborador
      const userDoc = await getDoc(doc(db, "users", user.uid));
      
      if (userDoc.exists() && userDoc.data().isCollaborator === true) {
        // Se for um colaborador, não redirecionar para seleção de categorias
        console.log('Usuário é um colaborador, não precisa selecionar categorias');
        setIsCollaborator(true);
        setHasCategoriesDoc(true); // Consideramos que já tem categorias
        setCheckingStatus(false);
        return;
      }
      
      // 2. Para usuários normais, verificar o documento de categorias como antes
      const userCategoriesDoc = await getDoc(doc(db, "userCategories", user.uid));
      
      if (userCategoriesDoc.exists()) {
        console.log('Documento de categorias encontrado para o usuário');
        setHasCategoriesDoc(true);
      } else {
        console.log('Documento de categorias NÃO encontrado - redirecionando para seleção');
        setHasCategoriesDoc(false);
      }
    } catch (error) {
      console.error('Erro ao verificar status do usuário:', error);
      // Se houver erro, assumimos que não tem o documento para forçar a seleção de categorias
      setHasCategoriesDoc(false);
    } finally {
      setCheckingStatus(false);
    }
  };

  // Se estamos verificando, mostrar um indicador de carregamento
  if (checkingStatus) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Verificando sua conta...</p>
      </div>
    );
  }

  // Se não tem documento de categorias E não é colaborador, redirecionar para seleção
  if (hasCategoriesDoc === false && !isCollaborator) {
    console.log('Redirecionando para seleção de categorias');
    return <Navigate to="/select-categories" replace />;
  }

  // Se tem documento ou é colaborador, renderizar o dashboard normalmente
  return children;
};

export default FirstLoginRedirect;